import React, { forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import Button, { type ButtonProps } from '@/components/common/Button'

interface ActionButtonProps extends ButtonProps {
  children: React.ReactNode
  type?: 'button' | 'submit' | 'reset'
}

export const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ children, className, type = 'button', ...props }, ref) => {
    return (
      <Button
        // @ts-ignore
        ref={ref}
        variant="soft-compact"
        className={twMerge(
          'h-6 px-1 shadow-sm text-[13px] text-primary-700 dark:text-primary-300 active:scale-100',
          className,
        )}
        type={type}
        {...props}
      >
        {children}
      </Button>
    )
  },
)

ActionButton.displayName = 'Task.ActionButton'
